// extracted by mini-css-extract-plugin
export default {"button_Primary":"hMbjcKlMO2DHziBR94hT","button_Secondary":"seXqO3mrKnszYXZHhXho","anchor_icon":"iCRKwfC8iOrOJ8D7bXmn"};